import { theme } from '../../common/ui/theme';

export const chartColors = [
    theme.colors.foreground.default,
    theme.colors.foreground.muted,
    theme.colors.foreground.subtle,
    theme.colors.foreground.disabled,
    theme.colors.accent.background,
];
